import { eq, getTableColumns } from "drizzle-orm";
import React, { createContext, useContext, useEffect } from "react";

import { db } from "@/db/db";
import type * as schema from "@/db/schema";
import { account } from "@/db/schema";
import { Account } from "@/db/types.ts";
import { useReactiveSelectQuery } from "@/models/hooks/useReactiveSelectQuery.ts";
import { TelemetryContext } from "../TelemetryProvider";

type MyAccountState = {
  myAccount?: typeof schema.account.$inferSelect;
  myAccountId?: string;
  setMyAccount: (acct: Account) => void;
};

export const MyAccountContext = createContext<MyAccountState>({
  setMyAccount: (_acct: Account) => void {},
});

const myAccountQuery = () =>
  db
    .select({ ...getTableColumns(account) })
    .from(account)
    .where(eq(account.mine, true))
    .limit(1);

const MyAccountProvider = ({ children }) => {
  const [myAccountId, setMyAccountId] = React.useState<string | undefined>(undefined);
  const [myAccount, setMyAccount] = React.useState<Account>(undefined);
  const { setAttribute } = useContext(TelemetryContext);

  const myAccounts = useReactiveSelectQuery(myAccountQuery, [], "MyAccountProvider:myAccountQuery", 0) ?? [];
  const localMyAccount = myAccounts?.[0];

  useEffect(() => {
    setMyAccount(localMyAccount);
    if (localMyAccount) {
      setAttribute("accountId", localMyAccount.id);
      setMyAccountId(localMyAccount.id);
    }
  }, [localMyAccount]);

  return (
    <MyAccountContext.Provider value={{ myAccountId, myAccount, setMyAccount }}>{children}</MyAccountContext.Provider>
  );
};

export default MyAccountProvider;
